import { render, staticRenderFns } from "./characterStory.vue?vue&type=template&id=191c0c44&scoped=true"
import script from "./characterStory.vue?vue&type=script&lang=js"
export * from "./characterStory.vue?vue&type=script&lang=js"
import style0 from "./characterStory.vue?vue&type=style&index=0&id=191c0c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c0c44",
  null
  
)

export default component.exports